const API_URL = 'https://anees-erp-cloud.anees-erp-ahmed.workers.dev';

function getStoredToken() {
  try {
    return (
      localStorage.getItem('eshara_token') ||
      localStorage.getItem('token') ||
      localStorage.getItem('authToken') ||
      localStorage.getItem('anees_token') ||
      ''
    );
  } catch (error) {
    return '';
  }
}

export async function apiFetch(path, options = {}) {
  const token = getStoredToken();

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  };

  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers
  });

  return response;
}

export { API_URL };
export default API_URL;

export function getApiList(data, key, fallbackKeys = []) {
  if (Array.isArray(data)) return data;
  const keys = [key, ...fallbackKeys].filter(Boolean);
  for (const k of keys) {
    if (Array.isArray(data?.[k])) return data[k];
  }
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
}
